export default "__VITE_ASSET__17ed6ed1__"